import { Box, Typography, styled } from "@mui/material";

import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "components/NumberFormats";
import useIsMobileView from "hooks/useIsMobileView";
import { useMemo } from "react";

export default function BoxPrice({
  title,
  imageCoin,
  price,
  coin,
  amountInterestRates,
  isBigValue = false
}) {
  const isMobileView = useIsMobileView();

  const profitLossColor = useMemo(() => {
    if (amountInterestRates > 0) return "success.main";
    else if (amountInterestRates < 0) {
      return "error.main";
    }

    return "text.main";
  }, [amountInterestRates]);

  const profitLossSign = useMemo(() => {
    if (amountInterestRates > 0) return "+";

    return "";
  }, [amountInterestRates]);

  const valueSize = useMemo(() => {
    if (isMobileView) {
      return isBigValue ? 'h4' : 'h5'
    } else {
      return isBigValue ? "h2" : "h3"
    }
  }, [isMobileView, isBigValue])

  return (
    <Box
      display="flex"
      flexDirection={isMobileView ? "row" : "column"}
      justifyContent="space-between"
    >
      <Typography
        variant={isMobileView ? "h6" : "h5"}
        paddingBottom={1.4}
        color="text.secondary"
        minWidth={isMobileView ? "90px" : "auto"}
      >
        {title}
      </Typography>

      <Box display="flex" flexDirection="column" minWidth="135px">
        <BoxCoin>
          {imageCoin &&
            <img src={DefaultUrlWeb + imageCoin} alt="USDT" />
          }
          <Typography
            variant={valueSize}
            color={profitLossColor}
            fontWeight={600}
            component="span"
          >
            <NumberFormats value={price} />
          </Typography>
          <Typography component="small" color="text.main" fontWeight={300}>
            {coin}
          </Typography>
        </BoxCoin>

        {(amountInterestRates || amountInterestRates === 0) && (
          <Typography
            variant={isMobileView ? "subtitle1" : "h5"}
            color={profitLossColor}
          >
            {profitLossSign} <NumberFormats value={amountInterestRates} /> %
          </Typography>
        )}

      </Box>
      <Box sx={{display: {xs: "block", md: "none"}}} />
    </Box>
  );
}

const BoxCoin = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  img: {
    width: "25px",
    marginRight: theme.spacing(1),
  },
  small: {
    fontSize: "12px",
    marginLeft: theme.spacing(0.7),
  },
}));
